import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useFormSubmit } from "./useFormSubmit";

import { sendForm } from "../slices/sendFormSlice";

export const usePasswordModal = () => {
    console.log("usePasswordModal вызван!");
    const dispatch = useDispatch();
    const formId = "passwordModal";
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);

    const fields = [
        {label: "Старый пароль", name: "old_password", validationRules: {required: true}},
        {label: "Новый пароль", name: "new_password",  validationRules: {required: true}},
        {label: "Подвердить новый пароль", name: "new_password_confirmation",  validationRules: {required: true}}
    ]

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const body = {
                old_password: formValues.old_password,
                new_password: formValues.new_password,
                new_password_confirmation: formValues.new_password_confirmation
            }

            const action = await dispatch(sendForm({body, url: '/change-password',token}));
            if (sendForm.fulfilled.match(action)) {
                // dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error
            }
        },
        successMessage: "Вы успешно поменяли пароль",
        fields,
        error
    })

    console.log("formId:", formId, "loadingStatus:", loadingStatus, "error:", error);

    return { formId, loadingStatus, handleChangePassword: handleSubmit }
}